export default "__VITE_ASSET__C$DyIKvo__"